import ThreePromise from './ThreePromise';
export default ThreePromise;
